import React, { Component } from 'react'
import { Translate } from 'react-localize-redux'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'

class SendRequestDialog extends Component {
	render() {
		const { open, isSaving, onSend, onClose } = this.props
		return (
			<Dialog open={open}>
				<DialogTitle>
					<Translate id='requirementRequest.sendRequestTitle' />
				</DialogTitle>
				<DialogContent>
					<Typography variant='body1'>
						<Translate id='requirementRequest.sendRequestMessage' />
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose} color='default' disabled={isSaving}>
						<Translate id='common.cancel' />
					</Button>
					<Button onClick={onSend} color='primary' variant='contained' disabled={isSaving}>
						{isSaving ? <CircularProgress size={20} /> : <Translate id='requirementRequest.send' />}
					</Button>
				</DialogActions>
			</Dialog>
		)
	}
}

export default SendRequestDialog
